module.exports = __webpack_public_path__ + "static/img/AtWuhu-1.0d85fb8a.jpg";